<template>
    <waitingBlock v-if="viewState.isLoading"></waitingBlock>
    <table v-else>
        <thead>
            <tr>
                <th style="line-height: 20px;" width="10px"></th>
                <th style="line-height: 20px;" width="40px">Time</th>
                <th style="line-height: 20px;">
                    <div class="w-100 d-flex align-items-center justify-content-between">
                        <div>Description</div>
                        <div class="d-flex align-items-center">
                            <span class="mr-2">Show Debug</span>
                            <ToggleInput :originalValue="viewState.showDebug" @onValueChanged="changeDebugValue" id="toggleDebug" class="p-0"></ToggleInput>
                        </div>
                    </div>
                </th>
                <th style="line-height: 20px;" class="text-center" width="40px">Level</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="logLine in preparedLogs" :key="logLine.id">
                <td></td>
                <td class="text-muted">{{logLine.timeOfDay}}</td>
                <td>{{logLine.description}}</td>
                <td class="text-center"><span class="status-pill" :title="logLine.logState"><span :class="`pill-${logLine.logState}`"></span></span></td>
            </tr>
        </tbody>
    </table>
</template>
<style lang="scss" scoped>
    table {
        width: 100%;
    }

    thead, thead tr:nth-child(1) th {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        background: white;
    }

    thead tr:nth-child(1) th {
        &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1px;
            background-color: #D2D2D2;
        }
    }

    td, th {
        padding: 15px 15px 15px 0;
        font-size: 13px;
        line-height: 16px;
    }

        td span {
            white-space: nowrap;
        }

            td span .decorator {
                margin-right: 10px;
            }

    th {
        color: #AAAAAA;
        padding: 22px 15px 22px 0;
    }

    tbody tr {
        color: #292C33;
        font-size: 13px;
        line-height: 16px;
        border-bottom: 1px solid #D2D2D2;
    }

    i {
        color: #D2D2D2;
    }

    .status-pill {
        background-color: #F0F1F3;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 18px;
        width: 18px;
    }

    .status-pill > span {
        border-radius: 50%;
        display: inline-block;
        height: 8px;
        width: 8px;
    }

    .pill-Debug {
        background-color: #777D83;
    }

    .pill-Info {
        background-color: #18B9E7;
    }

    .pill-Warning {
        background-color: #FFCC00;
    }

    .pill-Error {
        background-color: #FE6B5B;
    }
</style>
<script>
    import Moment from 'moment'
    import { HTTP } from "@/utils/http";
    import Apis from '@/apis/index'
    import { setTimeout } from 'timers';
    import WaitingBlock from'@/components/common/WaitingBlock'
    import ToggleInput from'@/components/common/ToggleInput'
    export default {
        name: 'PlanningLogList',
        components: { WaitingBlock, ToggleInput },
        computed: {
            scheduledDate() {
                return Moment(this.$route.params.planningDate);
            },
            preparedLogs() {
                return ((this.planningData || {}).logs || [])
                    .filter(itm => itm.logState != "Debug" || this.viewState.showDebug)
                    .sort((a, b) => a.id - b.id)
            }
        },
        mounted() {
            this.loadData();
        },
        data() {
            return {
                viewState: {
                    isLoading: false,
                    showDebug: false
                },
                planningData: null,
                response: null,
            }
        },
        methods: {
            changeDebugValue(newValue) { this.viewState.showDebug = newValue },
            onApiLoaded(response) {
                this.planningData = response.data.dataItem
            },
            onApiError(error) {
                this.planningData = error.response.data.dataItem
            },
            onApiCompleted() {
                this.viewState.isLoading = false;
            },
            loadData() {
                this.viewState.isLoading = true;
                HTTP.get(Apis.planning.details, {
                    params: {
                        scheduleDate: this.scheduledDate.format("YYYY-MM-DD"),
                        stationUid: this.$route.params.stationUid
                    }
                })
                    .then(this.onApiLoaded, this.onApiError)
                    .then(this.onApiCompleted);
            }
        }
    }
</script>
<style scoped>
</style>
